import { render, staticRenderFns } from "./ExamStudentAnswerDetail.vue?vue&type=template&id=69396164&scoped=true&"
import script from "./ExamStudentAnswerDetail.vue?vue&type=script&lang=js&"
export * from "./ExamStudentAnswerDetail.vue?vue&type=script&lang=js&"
import style0 from "./ExamStudentAnswerDetail.vue?vue&type=style&index=0&id=69396164&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69396164",
  null
  
)

export default component.exports